import { render, staticRenderFns } from "./LiveSyncView.vue?vue&type=template&id=24075244"
import script from "./LiveSyncView.vue?vue&type=script&lang=js"
export * from "./LiveSyncView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports